import { Component, ElementRef, HostListener, Input, OnInit } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import 'rxjs/add/operator/filter';

export interface DropdownState {
  visible: boolean;
  atTheBottom?: boolean;
  atTheLeft?: boolean;
}

@Component({
  selector: 'app-dropdown',
  template: `
    <div tabindex="-1" class="dropdown" [ngClass]="{'dropdown--active': state.visible, 'dropdown--at-the-bottom': state.atTheBottom, 'dropdown--at-the-left': state.atTheLeft}">
      <ng-content></ng-content>
    </div>
  `,
})
export class DropdownComponent implements OnInit {
  @Input() state: DropdownState;

  constructor(
    private ref: ElementRef,
    private router: Router) {}

  ngOnInit() {
    // Close on route change start
    this.router.events
      .filter(event => event instanceof NavigationStart)
      .subscribe(() => this.state.visible = false);
  }

  /**
   * Click outside the element
   */
  @HostListener('document:click', ['$event.target'])
  clickOutside(target?: HTMLElement) {
    if (target && ! this.ref.nativeElement.contains(target)) {
      this.state.visible = false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/dropdown/dropdown.component.ts